"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var src_1 = require("@wix/wix-instance-parser-js/dist/src");
var query_params_1 = require("../query-params");
exports.getLinguisticHeaderFromUrl = function (url) {
    var _a = query_params_1.getQueryParams(url), lang = _a.lang, dateNumberFormat = _a.dateNumberFormat, isPrimaryLanguage = _a.isPrimaryLanguage, instance = _a.instance;
    if (lang) {
        var instanceId = src_1.instanceValue.getValueFromInstance('instanceId', instance);
        return lang + "|" + dateNumberFormat + "|" + isPrimaryLanguage + "|" + instanceId;
    }
};
